module.exports = {
    BROKER_CUSTOM_WALLET_INVESTMENTS: '/myprofile/broker',
    BROKER_CUSTOM_WALLET_PORTFOLIO_ACCOUNT_TYPE: 3,
    BROKER_CUSTOM_WALLET_CREATE_ACCOUNT_ID: 0,
    BROKER_CUSTOM_WALLET_GENERAL_VIEW: '0',
    BROKER_CUSTOM_WALLET_CREATE_INPUT_LIMIT: '50',
    BROKER_CUSTOM_CONFIG_WALLET_NAME_LIMIT: 38,
    BROKER_CUSTOM_CONFIG_WALLET_GENERAL_NAME: 'Total',
    BROKER_CUSTOM_WALLET_CONTRACT_FUNDS_TYPE: 'funds',
    BROKER_CUSTOM_WALLET_CONTRACT_VALORES_TYPE: 'valores',
    BROKER_CUSTOM_WALLET_CONTRACT_PLANS_TYPE: 'plans',
    BROKER_CUSTOM_WALLET_PG_VIEW: 'WEALTH_CUSTOM_PG_VIEW',
    BROKER_CUSTOM_WALLET_MAX_ON_CREATE: "Can't to create more than 15 portfolios by user.",
};
